import { isDefined } from '@freelancer/utils';
import type { ServiceOfferingApi } from 'api-typings/service_offerings/service_offerings';
import { transformServiceOfferingDiscountDetails } from './service-offerings-discount-details.transformers';
import type { ServiceOffering } from './service-offerings.model';
import { transformServiceOfferingShopCategoryServicePriceType } from '../service-offering-shop-category-services/service-offering-shop-category-services.transformer';

export function transformServiceOffering(
  serviceOffering: ServiceOfferingApi,
): ServiceOffering {
  return {
    id: serviceOffering.id,
    creatorId: serviceOffering.creator_id,
    description: serviceOffering.description,
    richDescription: serviceOffering.rich_description,
    status: serviceOffering.status,
    title: serviceOffering.title,
    createDate: isDefined(serviceOffering.create_date)
      ? serviceOffering.create_date * 1000
      : undefined,
    jobIds: serviceOffering.jobs?.map(job => job.id),
    seoUrl: serviceOffering.seo_url,
    // T290741 Filter should happen in the backend
    attachments: serviceOffering.attachments?.filter(
      attachment => !attachment.delete_date,
    ),
    duration: serviceOffering.duration,
    price: serviceOffering.price,
    priceType: transformServiceOfferingShopCategoryServicePriceType(
      serviceOffering.price_type,
    ),
    discountDetails: isDefined(serviceOffering.discount_details)
      ? transformServiceOfferingDiscountDetails(
          serviceOffering.discount_details,
        )
      : undefined,
  };
}
